module.exports = __webpack_public_path__ + "static/assets/d5a4ec44744da566714cb1d48cd30801.svg";